<input
  #fileInput
  type="file"
  style="display: none"
  (change)="uploadFile()"
  [accept]="accept"
/>
<a
  pButton
  class="block p-button-text"
  [ngClass]="{ 'h-full': isFullHeight }"
  href=""
  (click)="selectFile($event)"
>
  <ng-content></ng-content>
</a>
